<template>
  <div
    class="modal"
    id="menu-item-dialog"
    :style="myModalStyle"
  >
    <div
      class="modal__header"
      :style="myHeaderStyle"
    >
      <v-layout row>
        <v-flex
          xs12
          sm12
          md12
          lg10
          offset-lg1
          xl8
          offset-xl2
        >
          <v-layout
            row
            align-center
          >
            <v-flex xs2>
              <v-btn
                icon
                :color="theme.dialog_header_title_color"
                flat
                @click="closeDialog"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
            <v-flex
              xs10
              mr-1
              text-xs-right
              class="nowrap-text"
            >
          <span
            v-if="menuItem"
            :style="myTitleStyle"
            class="name"
          >{{ $t('add_item') }}</span>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
    <div
      class="modal__content"
      id="menu-item-dialog-content"
      :style="myContentStyle"
      v-body-scroll-lock="menuItemDialog"
    >
      <v-layout row>
        <v-flex
          xs12
          sm12
          md12
          lg10
          offset-lg1
          xl8
          offset-xl2
        >
          <div v-if="menuItem">
            <item-detail :item="menuItem" />
            <div class="text-xs-center">
              <v-btn
                icon
                flat
                small
                @click="minusQty"
              >
                <v-icon :color="theme.menudialog_title_color" medium>remove_circle_outline</v-icon>
              </v-btn>
              <span :style="myQtyStyle">{{ menuItemQty }}</span>
              <v-btn
                icon
                flat
                small
                @click="plusQty"
              >
                <v-icon :color="theme.menudialog_title_color" medium>add_circle_outline</v-icon>
              </v-btn>
            </div>
            <div v-if="allowSpecialRequest || specialRequestCats">
              <v-divider class="mt-2 mb-2" />
              <span
                :style="myQtyStyle"
              >{{ parseInt(rid) === 962 ? $t('remarks'): $t('special_request_if_any') }}</span>
              <v-textarea
                v-model="specialReq"
                solo
                counter="80"
                maxlength="80"
                rows="3"
                class="mt-1 mb-2 special-req"
                name="speReq"
                placeholder="E.g: Less sugar"
              />
            </div>
            <div
              class="text-xs-center mt-3"
              v-if="iOS && inIframe"
            >
              <v-btn
                flat
                dark
                :color="theme.menudialog_title_color"
                @click="closeDialog"
              >
                Cancel
              </v-btn>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div
      class="modal__footer"
      :style="myFooterStyle"
    >
      <v-layout row>
        <v-flex
          xs12
          sm12
          md12
          lg10
          offset-lg1
          xl8
          offset-xl2
        >
          <v-btn
            block
            dark
            large
            :color="theme.btn_color_primary"
            @click="addToCart"
          >
            <v-layout row>
              <v-flex
                xs12
                class="text-xs-center"
                v-if="this.inCart"
              >
                {{ fromCustomSets ? $t('update') : $t('update') + ' &#183; ' + $n(this.amount, 'currency') }}
              </v-flex>
              <v-flex
                xs12
                class="text-xs-center"
                v-else
              >
                {{ fromCustomSets ? $t('add_to_custom_set') : $t('add_to_cart') + ' &#183; ' + $n(this.amount, 'currency') }}
              </v-flex>
            </v-layout>
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto'
import { mapGetters } from 'vuex'
import ItemDetail from '~/components/ItemDetail'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export default {
  name: 'voucher-item-dialog-component',
  components: {
    'item-detail': ItemDetail
  },
  props: {
    fromPromoItemsDialog: {
      type: Boolean,
      default: false
    },
    fromCustomSets: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      specialReq: '',
      inCart: false
    }
  },
  computed: {
    ...mapGetters('config', [
      'theme', 'iOS', 'inIframe', 'allowSpecialRequest', 'rid', 'config'
    ]),
    ...mapGetters('menu', [
      'menuItem', 'menuItemPrice', 'menuItemQty', 'menuItemReady',
      'menuItemCourseItems', 'menuItemOptions', 'menuItemToppings',
      'menuItemStatus', 'menuItemRequired', 'menuItemSpecialReq',
      'menuItemDialog'
    ]),
    ...mapGetters('cart', [
      'cartLimitReached', 'itemQtyInCart'
    ]),
    ...mapGetters('voucher', [
      'promotionDialog', 'promotionVoucher', 'promotionItem', 'vouchers',
      'allVouchers'
    ]),
    specialRequestCats() {
      let special_req_cats = JSON.parse(this.config.special_request_cats)
      if (parseInt(this.config.enable_special_request) === 2 && special_req_cats.length > 0) {
        return special_req_cats.includes(this.menuItem.category_id)
      } else {
        return false
      }
    },
    myModalStyle () {
      return {
        backgroundColor: this.theme.menu_bg_color
      }
    },
    myHeaderStyle () {
      return {
        backgroundColor: this.theme.dialog_header_bg_color
      }
    },
    myTitleStyle () {
      return {
        color: this.theme.dialog_header_title_color
      }
    },
    myContentStyle () {
      return {
        position: 'absolute',
        bottom: '64px',
        top: '48px',
        backgroundColor: this.theme.dialog_content_bg_color
      }
    },
    myFooterStyle () {
      return {
        position: 'absolute',
        bottom: 0,
        backgroundColor: this.theme.footer_bg_color
      }
    },
    myQtyStyle () {
      return {
        color: this.theme.menudialog_title_color
      }
    },
    amount () {
      if (this.menuItemPrice && this.menuItemQty) {
        return this.menuItemPrice * this.menuItemQty
      }
      return 0
    },
    minQty () {
      if (!this.menuItem.min_quantity) return 1
      return this.menuItem.min_quantity
    },
    maxQty () {
      let maxQuantity = this.menuItem.max_quantity ? this.menuItem.max_quantity : 10;

      if (this.menuItem.inventory_left <= maxQuantity) {
        maxQuantity = this.menuItem.inventory_left;
      }

      // 如果当前数量+步进数量大于最大数量，则禁止继续增加
      console.log(this.menuItemQty ,this.stepQty,this.menuItemQty + this.stepQty, maxQuantity)
      if (this.menuItemQty + this.stepQty > maxQuantity) {
        maxQuantity = this.menuItemQty
      }

      return maxQuantity;
    },
    stepQty () {
      if (!this.menuItem.step_quantity) return 1
      return this.menuItem.step_quantity
    }
  },
  methods: {
    minusQty () {
      if (this.menuItemQty > this.minQty) {
        this.$store.dispatch('menu/changeMenuItemQty', -this.stepQty)
      }
    },
    plusQty () {
      if (this.menuItemQty < this.maxQty) {
        this.$store.dispatch('menu/changeMenuItemQty', this.stepQty)
      }
    },
    closeDialog () {
      // Re-enable body scroll
      // enableBodyScroll(document.getElementById('menu-item-dialog-content'))
      this.$store.dispatch('voucher/hideVoucherItemDialog')
      if (this.iOS && this.inIframe) {
        if (this.$route.params.return === 'order') {
          this.$router.push({ name: 'order', params: { id: this.$route.params.id }})
        } else {
          this.$router.push({ name: this.$route.params.return })
        }
      }
    },
    async addToCart () {
      if (this.rInfoExpiredAlert()) {
        return
      }
      if (this.cartLimitReached(this.menuItem.plu_id)) {
        this.$store.dispatch('responseMessage', {
          type: 'error',
          title: 'Unable to add',
          text: this.$t('error_cart_limit'),
          modal: true
        })
        return
      }
      await this.$store.dispatch('menu/processMenuItem', 'both')
      if (this.menuItemReady === false) {
        this.$store.dispatch('responseMessage', {
          type: 'error',
          text: 'Please select: ' + this.menuItemRequired.join(', '),
          title: 'Please complete selection',
          modal: true
        })
        const options = {
          container: '#menu-item-dialog-content',
          easing: 'ease-in',
          offset: -20,
          force: true,
          cancelable: false,
          x: false,
          y: true
        }
        const element = '#' + this.menuItemRequired[0].replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
        VueScrollTo.scrollTo(element, 500, options)
        return
      }
      // await this.$store.dispatch('menu/checkItemStatus', this.menuItem)
      // if (this.menuItemStatus !== 1) {
      //   this.$store.dispatch('responseMessage', {
      //     type: 'error',
      //     text: 'Sorry, the item is currently unavailable. Please select other items.',
      //     title: 'The item is currently unavailable',
      //     modal: true
      //   })
      //   return
      // }
      this.$store.dispatch('menu/setMenuItemSpecialReq', this.specialReq)
      let quantity = this.menuItemQty
      if (!this.menuItem.courses && this.inCart) {
        quantity = Math.abs(this.menuItemQty - this.itemQtyInCart(this.menuItem.plu_id))
      }
      const params = {
        voucher_id: this.promotionVoucher.voucher_id,
        member_voucher_id: this.promotionVoucher.id,
        item: JSON.parse(JSON.stringify(this.menuItem)),
        quantity: quantity,
        in_cart: this.inCart,
        final_price: this.menuItemPrice,
        options: this.menuItemOptions,
        toppings: this.menuItemToppings,
        set_course_items: this.menuItemCourseItems,
        special_req: this.menuItemSpecialReq
      }
      if (this.fromCustomSets) {
        this.$emit('add-item', params)
        return
      }
      if (this.fromPromoItemsDialog) params.is_promo = true
      this.$store.dispatch('cart/addCartItem', params)
      // Re-enable body scroll
      // enableBodyScroll(document.getElementById('menu-item-dialog-content'))
      this.$store.dispatch('voucher/hideVoucherItemDialog')
      if (this.iOS && this.inIframe) {
        if (this.$route.params.return === 'order') {
          this.$router.push({ name: 'order', params: { id: this.$route.params.id }})
        } else {
          this.$router.push({ name: this.$route.params.return })
        }
      }

      this.$store.dispatch('responseMessage', {
        type: 'success',
        text: this.$t('successfully_added_item'),
        timeout: 1800,
        noBtn: this.$mq === 'sm' || this.$mq === 'md' || this.$mq === 'lg' || this.$mq === 'xl'
      })
    }
  },
  beforeMount () {
    this.menuItem ? this.$bus.$emit('showFullLoading', false) : this.$bus.$emit('showFullLoading', true)
  },
  watch: {
    menuItem(val) {
      val ? this.$bus.$emit('showFullLoading', false) : this.$bus.$emit('showFullLoading', true)
    }
  },
  mounted () {
    if (this.menuItem && this.menuItem.courses.length === 0) {
      if (this.itemQtyInCart(this.menuItem.plu_id) <= 0) {
        this.$store.dispatch('menu/setMenuItemQty', 1)
      } else {
        this.inCart = true
        this.$store.dispatch('menu/setMenuItemQty', this.itemQtyInCart(this.menuItem.plu_id))
      }
    } else {
      this.$store.dispatch('menu/setMenuItemQty', 1)
    }
    // Disable body scroll
    // disableBodyScroll(document.getElementById('menu-item-dialog-content'))
  }
}
</script>

<style scoped>
.modal {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 200;
}
.modal__header {
  height: 48px;
}
.modal__footer {
  width: 100%;
  height: 64px;
  padding: 4px 10px;
}
.modal__content {
  width: 100%;
  overflow-y: auto;
  padding: 10px 24px;
}
.name {
  padding-right: 16px;
}
.nowrap-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.special-req {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/VoucherItemDialog.vue